
import { useState, useEffect } from 'react';
import { TrainingSession } from '@/types/training';

export function useSortedSessions(sessions: TrainingSession[] | null) {
  const [sortedSessions, setSortedSessions] = useState<TrainingSession[]>([]);

  useEffect(() => {
    // Handle null or undefined sessions
    if (!sessions || !Array.isArray(sessions)) {
      setSortedSessions([]);
      return;
    }

    try {
      const allSessionsForDialogs = sessions
        .filter(session => session && session.beltRank && session.stripeCount !== undefined)
        .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());

      setSortedSessions(allSessionsForDialogs);
    } catch (error) {
      console.error('Error sorting sessions:', error);
      setSortedSessions([]);
    }
  }, [sessions]);

  return sortedSessions;
}
